import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Talent from "../pages/talent/page";
import Entertainment from "../pages/entertainment/page";
import Farm from "../pages/farm/page";
import EC from "../pages/ec/page";
import Company from "../pages/company/page";
import News from "../pages/news/page";
import NewsDetail from "../pages/news/detail";
import Contact from "../pages/contact/page";
import Privacy from "../pages/privacy/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/talent", element: <Talent /> },
  { path: "/entertainment", element: <Entertainment /> },
  { path: "/farm", element: <Farm /> },
  { path: "/ec", element: <EC /> },
  { path: "/company", element: <Company /> },
  { path: "/news", element: <News /> },
  { path: "/news/:id", element: <NewsDetail /> },
  { path: "/contact", element: <Contact /> },
  { path: "/privacy", element: <Privacy /> },
  { path: "*", element: <NotFound /> },
];

export default routes;